import React from "react";

const CLASS_COLOR = {
  cold:       { bg: "#EEF0F8", fg: "#6B6E89", border: "#E6E8F2" },
  warm:       { bg: "#FFF6E6", fg: "#B97509", border: "#FBE0A4" },
  hot:        { bg: "#FFE9E3", fg: "#C44523", border: "#FBC8B8" },
  enterprise: { bg: "#EDE9FE", fg: "#5B4DFF", border: "#C8BFFF" },
};

/** Pill rendering a lead's classification + score. */
export function LeadScorePill({ score, classification, testId }) {
  if (score == null && !classification) return <span className="text-xs text-muted-foreground">—</span>;
  const cls = (classification || "cold").toLowerCase();
  const c = CLASS_COLOR[cls] || CLASS_COLOR.cold;
  return (
    <span
      data-testid={testId}
      style={{
        display: "inline-flex", alignItems: "center", gap: 6,
        background: c.bg, color: c.fg, border: `1px solid ${c.border}`,
        padding: "2px 8px", borderRadius: 999, fontSize: 11,
        fontWeight: 600, textTransform: "capitalize",
      }}
    >
      <span style={{
        width: 5, height: 5, borderRadius: "50%", background: c.fg,
      }} />
      {cls} · {score ?? 0}
    </span>
  );
}

/** Compact qualification summary — business type + intent + first pain. */
export function QualSummary({ qualification }) {
  if (!qualification) return <span className="text-xs text-muted-foreground">—</span>;
  const { business_type, intent, pain_points } = qualification;
  const bits = [];
  if (business_type) bits.push(business_type);
  if (intent) bits.push(intent.replace(/_/g, " "));
  if (pain_points && pain_points.length) {
    bits.push(`pain: ${pain_points[0].replace(/_/g, " ")}${pain_points.length > 1 ? ` +${pain_points.length - 1}` : ""}`);
  }
  if (!bits.length) return <span className="text-xs text-muted-foreground">—</span>;
  return (
    <span className="text-xs text-muted-foreground" style={{ lineHeight: 1.4 }}>
      {bits.join(" · ")}
    </span>
  );
}
